import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Icon, Txt } from '@vst/beam';
import { KeyboardArrowDown } from '@vst/beam-icons/icons';
import { useTranslation } from 'react-i18next';

import { useShowAddonsShop } from '@app/hooks';
import { selectHasAddons } from '@app/redux';
import { selectUserInfo } from '@app/redux/userInfo';

import { ExtendedDropdownItems } from './ExtendedDropdown';
import { getNavItems } from './utils';
import { NavBarProps, ProfileTab } from '../../types';

import styles from './styles.module.scss';

const NavBarDropdown = ({ currentTab, handleTabClick }: NavBarProps): JSX.Element => {
  const { t } = useTranslation('Profile');
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const {
    userInfo: { accountType },
  } = useSelector(selectUserInfo);

  const showAddonsShop = useShowAddonsShop();
  const hasAddons = useSelector(selectHasAddons);

  const handleClick = () => {
    setShowDropdown(!showDropdown);
  };

  const handleTabSwitch = (tabId: ProfileTab) => {
    handleTabClick(tabId);
    setShowDropdown(false);
  };

  const { selectedItem } = getNavItems(currentTab, accountType, t, showAddonsShop || hasAddons);

  return (
    <div
      data-cy="profile-nav-dropdown"
      className={showDropdown ? styles['dropdownContainerOpen'] : styles['dropdownContainer']}
    >
      <button
        className={showDropdown ? styles['currentTabWhenExpanded'] : styles['currentTabWhenCollapsed']}
        onClick={handleClick}
      >
        <div className={styles['label']}>
          <Icon icon={selectedItem[0]?.icon} color="teal_600" />
          <Txt variant="labelLarge" ml="8px" color="regular">
            {selectedItem[0]?.label}
          </Txt>
        </div>
        <div className={showDropdown ? styles['rotate180'] : styles['rotate0']}>
          <Icon icon={KeyboardArrowDown} color="gray_600" />
        </div>
      </button>
      {showDropdown && (
        <ExtendedDropdownItems currentTab={currentTab} accountType={accountType} handleTabSwitch={handleTabSwitch} />
      )}
    </div>
  );
};

export default NavBarDropdown;
